module.exports = __webpack_public_path__ + "img/note.5dbf0299.svg";